import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import EsgCalculatorView from "./EsgCalculatorView";
import EsgDashboard from "components/dashboard/esg/EsgDashboard";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { VideoTutorialButton } from "components/modal/video-modal/video-tutorial-button/VideoTutorialButton";
import { VideoModal } from "components/modal/video-modal/VideoModal";
import { OUR_IMPACT_DASHBOARD_ROUTE, SUSTAINABILITY_DASHBOARD_ROUTE } from "components/router/Routes";
import { TutorialVideoLink } from "domain/tutorialVideos";
import { StoreState } from "store";

export function EsgDashboardView(): JSX.Element {
    const { t } = useTranslation();
    const tenantDetails = useSelector(
        (state: StoreState) => state.tenantDetailsReducer.stack[state.tenantDetailsReducer.stack.length - 1]
    );
    const viewActions = OUR_IMPACT_DASHBOARD_ROUTE.isAccessibleTo(tenantDetails) ? <EsgCalculatorView /> : undefined;

    const [showVideoModal, setShowVideoModal] = React.useState(false);

    return (
        <>
            <ApplicationLayout
                viewTitle={t("EsgDashboardView.blanccosImpact")}
                view={<EsgDashboard />}
                viewContainer={false}
                mainRoute={SUSTAINABILITY_DASHBOARD_ROUTE}
                viewActions={
                    <>
                        <VideoTutorialButton onClick={() => setShowVideoModal(true)} />
                        {viewActions}
                    </>
                }
            />
            <VideoModal
                isOpen={showVideoModal}
                hideModal={() => setShowVideoModal(false)}
                linkUrl={TutorialVideoLink.SUSTAINABILITY}
            />
        </>
    );
}

export default EsgDashboardView;
